"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogType;
(function (DialogType) {
    DialogType["TEACH"] = "teach";
    DialogType["TRAINDIALOG"] = "traindialog";
    DialogType["LOGDIALOG"] = "logdialog";
})(DialogType = exports.DialogType || (exports.DialogType = {}));
//# sourceMappingURL=Session.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/Session.js
// module id = 738
// module chunks = 0